import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a10bb63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compositionCard__header" }
const _hoisted_2 = { class: "fw_700" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "compositionCard__body"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "table table-striped mb-2" }
const _hoisted_8 = { class: "fs_14" }
const _hoisted_9 = { class: "me-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["compositionCard", { 'compositionCard--pending': !_ctx.row.materialsAssigned }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.row.name), 1),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.row.materialsAssigned)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-tertiary btn-sm",
                  disabled: _ctx.actionDisabled,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Associate and calculate",
                    text: "Associate and calculate"
                  })
                ], 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-secondary btn-sm",
                  disabled: _ctx.actionDisabled,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit')))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Edit",
                    text: "Edit"
                  })
                ], 8, _hoisted_4))
          ], 64))
        : (!_ctx.row.materialsAssigned)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Not filled yet",
              text: "Not filled yet",
              class: "fs_14"
            }))
          : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.default || _ctx.row.materialsAssigned)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.row.materialsAssigned && _ctx.row.getMaterialsCo2eEmissions.length == 0)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "No material",
                text: "No material",
                class: "fs_14 fw_700"
              }))
            : (_ctx.row.materialsAssigned)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Material",
                            text: "Material"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Percentage",
                            text: "Percentage"
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "CO2e",
                            text: "CO2e"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.getMaterialsCo2eEmissions, (share, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(share.material.text), 1),
                          _createElementVNode("td", null, _toDisplayString(share.percentage.toFixed(2)) + "%", 1),
                          _createElementVNode("td", null, _toDisplayString(share.co2e.toFixed(4)), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Country",
                      text: "Country",
                      class: "fw_700 me-1"
                    }),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.row.selectedCountry.text), 1),
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total",
                      text: "Total",
                      class: "fw_700 me-1"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.row.getCo2eEmissions.toFixed(4)), 1),
                    _createVNode(_component_localized_text, {
                      localizedKey: "CO2e",
                      text: "CO2e",
                      class: "ms-1"
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}